import { get, handleError } from '@/lib/http-adapter';
import type { ResolvedTerms, TermsScope } from '@/services/terms';

export type PublicTermsEntityFamily =
  | 'CLASS'
  | 'CLASS_PACK'
  | 'SUBSCRIPTION'
  | 'GIFT_CARD';

export type PublicTermsCoverage =
  | { scope: 'STUDIO' }
  | { scope: 'FAMILY'; family: TermsScope }
  | {
      scope: 'ENTITY';
      family: PublicTermsEntityFamily;
      entity_name: string;
      entity_slug: string;
    };

export interface PublicTermsListItem {
  terms_document_id: string;
  title: string;
  version: number;
  published_at: string;
  coverage: PublicTermsCoverage[];
  path: string;
}

export interface TermsRole {
  type: TermsScope;
  slug?: string;
}

export const getPublicTermsList = async (): Promise<
  PublicTermsListItem[] | undefined
> => {
  try {
    const response = await get<{ terms_documents: PublicTermsListItem[] }>(
      '/public/terms'
    );
    return response?.terms_documents ?? [];
  } catch (error) {
    handleError(error);
  }
};

export const getRoleTerms = async (
  params: TermsRole
): Promise<ResolvedTerms[] | undefined> => {
  try {
    const response = await get<{ resolved_terms_list: ResolvedTerms[] }>(
      '/public/terms/resolve',
      { params }
    );
    return response?.resolved_terms_list ?? [];
  } catch (error) {
    handleError(error);
  }
};
